"use client";

import { RootProvider } from "fumadocs-ui/provider/next";
import SearchDialog from "@/lib/docs/components/search";
import type { ReactNode } from "react";

export function Provider({ children }: { children: ReactNode }) {
  return (
    <RootProvider
      search={{
        SearchDialog,
      }}
      theme={{
        enabled: true,
        storageKey: "docs-theme",
        // forcedTheme: "dark",
        // defaultTheme: "light",
        enableSystem: true,
      }}
    >
      {children}
    </RootProvider>
  );
}
